export default __webpack_public_path__ + "static/media/card-arrow-gold.cb8deece.svg";